module.exports = __webpack_public_path__ + "img/facebook-ads.97cbbb92.png";